import { getToken, setToken, removeToken, setPermission, getPermission, removePermission, setUserInfo } from '@/utils/auth'
import { Message } from 'element-ui'
import { getCompanyInfo, referenceUserProfile} from '@/api/base'
import {getWechatAppInfo} from '@/api/firm';
const state = {
    token: getToken(),
    userInfo: {}, // 当前登录的用户信息
    roles: [],
    companyInfo: {},
    wechatApplication: null
}

const mutations = {
    SET_TOKEN: (state, token) => {
        state.token = token
    },
    SET_USER_INFO: (state, info) => {
        state.userInfo = info
    },
    SET_ROLES: (state, roles) => {
        state.roles = roles
    },
    SET_COMPANY: (state, info)  => {
        state.companyInfo = info;
    },
    // 修改用户头像
    SET_USER_AVATAR: (state, avatar) => {
        state.userInfo.avatar = avatar
    },
    SET_WECHAT_APPLICATION: (state, info) => {
        state.wechatApplication = info;
    }
}

const actions = {
    /** 用户登录 */
    login({ commit, dispatch}, data) {
      return new Promise((resolve) => {
        // 清空面包屑导航
        commit('RESETKEEPALIVELIST',{}, {root: true});
        // 保存token
        commit('SET_TOKEN', data.token);
        setToken(data.token);
        // 保存用户信息
        commit('SET_USER_INFO', data.profile);
        setUserInfo({
            id: data.profile.id,
            name: data.profile.name,
            mobile: data.profile.mobile,
        })
        // 保存用户权限
        commit('SET_ROLES', data?.profile?.permissions || []);
        setPermission(data?.profile?.permissions || []);

        dispatch('initGlobalCompany');
        dispatch('const/initNoticeList', {}, {root: true});
        dispatch('getCurrentWechatInfo');
        resolve();
      })
    },
    // 免密登录
    ssoLogin ({ commit, dispatch}, token) {
        return new Promise((resolve) => {
          // 清空面包屑导航
          commit('RESETKEEPALIVELIST',{}, {root: true});
          // 保存token
          commit('SET_TOKEN', token);
          setToken(token);
          dispatch('getUserInfoByToken', token);
          dispatch('initGlobalCompany');
          dispatch('const/initNoticeList', {}, {root: true});
          dispatch('getCurrentWechatInfo');
          resolve();
        })
      },
    // 切换公司
    toggleCompany ({ commit, dispatch }, data) {
        // 保存用户信息
        commit('SET_USER_INFO', data);
        setUserInfo({
            id: data.id,
            name: data.name,
            mobile: data.mobile,
        })
        // 保存用户权限
        commit('SET_ROLES', data?.permissions || []);
        setPermission(data?.permissions || []);
        // 其他信息初始化
        dispatch('initGlobalCompany');
        dispatch('const/initNoticeList', {}, {root: true});
        dispatch('getCurrentWechatInfo');
    },
    /** 根据token获取用户登录信息 */
    getUserInfoByToken ({ commit, dispatch }) {
        if (!state.token) return null;
        return new Promise((resolve, reject) => {
            referenceUserProfile().then((response = {}) => {
                commit('SET_USER_INFO', response)
                commit('SET_ROLES', response.permissions || [])
                setPermission(response.permissions || [])
                setUserInfo({
                    id: response.id,
                    name: response.name,
                    mobile: response.mobile,
                })
                dispatch('initGlobalCompany');
                dispatch('const/initNoticeList', {}, {root: true});
                dispatch('getCurrentWechatInfo');
                resolve()
            }).catch(err => {
                Message({
                    message: err.message,
                    type: 'error',
                    duration: 3 * 1000
                })
                reject(err)
            })
      })
    },
    /** 获取当前企业自建应用详情 */
    getCurrentWechatInfo ({ commit }) {
        if (!state.token) return null;
        return new Promise((resolve, reject) => {
            getWechatAppInfo().then((response) => {
                commit('SET_WECHAT_APPLICATION', response);
                resolve();
            }).catch(err => {
                reject(err)
            })
      })
    },
    /** 退出登录 */
    logout({ dispatch, commit }) {
        return new Promise((resolve) => {
            dispatch('resetToken')
            resolve()
        })
    },
    /** 清空token */
    resetToken({ commit }) {
        commit('SET_TOKEN', '')
        commit('SET_USER_INFO', {})
        commit('SET_ROLES', [])
        removeToken()
        removePermission()
    },
    /**判断是否有权限 */
    hasPermission ({}, permission) {   
        return new Promise((resolve) => {
            const userRoles = getPermission();
            if (userRoles[0] === '*' || permission === '*') {
                resolve(true);
                return null;
            }
            // 判断是否是多个类型
            const item = permission.split(',');
            let index = -1;
            userRoles.map(v => {
                if (item.indexOf(v) >= 0) index = 1;
            })
            resolve(index >= 0);
        })
    },
    /** 初始化全局公司信息 */
    initGlobalCompany ({state, commit}) {
        if (!state.token) return null;
        getCompanyInfo().then((response = {}) => {
            commit('SET_COMPANY', response);
        }).catch(err => {})
    }
}
export default {
    namespaced: true,
    state,
    mutations,
    actions
}
